import type { TaskStatus } from "@quovy/types";

import { STATUS_LABELS } from "./task-status";
import { TaskStatusIcon } from "./task-status-icon";

export function TaskStatusLabel({ status }: { status: TaskStatus }) {
  return (
    <span className="inline-flex min-w-0 items-center gap-2 text-[13px]">
      {/* The icon's own label would repeat the visible name to screen readers. */}
      <span aria-hidden className="inline-flex">
        <TaskStatusIcon status={status} tooltip={false} />
      </span>
      <span className="truncate">{STATUS_LABELS[status]}</span>
    </span>
  );
}
